/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressV0 } from './addressV0';
import { SapCountryCodes } from './sapCountryCodes';


/**
 * An iQEnergy Object
 */
export interface AddressListV0 { 
    /**
     * 
     */
    addressList?: Array<AddressV0>;
    country?: SapCountryCodes;
}
export namespace AddressListV0 {
}


